import { Button } from "@accessdev/arc-ui-react";
import { Trans } from "@lingui/react/macro";
import classNames from "classnames";
import React from "react";
import { useNavigate, useLocation } from "react-router";
import { ROUTES } from "../../constants/Routes";
import "./store404.scss";

function Store404({ fromModal }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <section className={classNames("Store404", { fromModal })}>
      <h1 className="Store404-heading">Oops!</h1>
      <div className="Store404-body">
        <p>
          <Trans>Well this is embarrassing; we can't find the content you're looking for.</Trans>
        </p>
        <p>
          <Trans>It may have been moved, or is no longer available.</Trans>
        </p>
      </div>
      {!fromModal && (
        <div className="Store404-btns">
          <Button
            onClick={() =>
              location.from && location.from === ROUTES.DIRECTOR_PATH
                ? navigate(ROUTES.HOME_PATH)
                : navigate(-1)
            }
            displayStyle="primary-outlined"
          >
            <Trans>Back</Trans>
          </Button>
          <Button onClick={() => navigate(ROUTES.HOME_PATH)}>
            <Trans>Home</Trans>
          </Button>
        </div>
      )}
    </section>
  );
}

export default Store404;
